export enum AgreementStatusStrings {
  DRAFT = 'draft',
  PENDING = 'pending',
  VALID = 'valid',
  FULLFILLED = 'fullfilled',
  CANCELLED = 'cancelled',
  REJECT = 'reject',
}
